// get id 
export const getLayerIdForRequest = (pOption: string): string => {
  const id = pOption === 'sensibility' ? '108' : '109';
  return id;
};
